const CAPSULES_ENDPOINT = {
    ALL_CAPSULES: '/capsules',
    ONE_CAPSULES: '/capsules/:id',
    COUNT_CAPSULES: '/capsules/count',
    RECENT_CAPSULES: '/capsules/recent',
    RESUME_CAPSULES: '/capsules/resume/:token',
    ORDER_INFORMATION: '/capsules/order-information/:id',
}

const CAPSULES_CONFIGURATIONS_ENDPOINT = {
    ALL_CAPSULES_CONFIGURATIONS: '/capsules/configurations',
    ONE_CAPSULES_CONFIGURATIONS: '/capsules/configurations/:id',
    COUNT_CAPSULES_CONFIGURATIONS: '/capsules/configurations/count',

}

const USERS_ENDPOINT = {
    ALL_USERS: '/users/all',
    ONE_USER: '/users/read/:id',
}

const CUSTOMERS_ENDPOINT = {
    ALL_CUSTOMERS_FOR_USER: '/customers',
    ONE_CUSTOMER: '/customers/read/:id',
}

const MIXTURES_ENDPOINT = {
    ALL_PHYSIQUES_MIXTURES: '/mixtures/physiques',
    ALL_EFFLUENCES_MIXTURES: '/mixtures/effluences',
    ALL_OTHERS_MIXTURES: '/mixtures/others',
    GET_MIXTURE: '/mixtures/:id',

}
const CUSTOM_MIXTURES_ENDPOINT = {
    ALL_CUSTOM_MIXTURES: '/mixtures/custom',
    COUNT_CUSTOM_MIXTURES_WITH_PARAM: '/mixtures/custom/count/:param',
    COUNT_TOTAL_CUSTOM_MIXTURES: '/mixtures/custom/count',
}

const CATALOGUE_MIXTURES_ENDPOINT = {
    ALL_CATALOGUE_MIXTURES: '/mixtures/catalogue',
    COUNT_CATALOGUE_MIXTURES_WITH_PARAM: '/mixtures/catalogue/count/:param',
    COUNT_TOTAL_CATALOGUE_MIXTURES: '/mixtures/catalogue/count',
}

const DILUTIONS_ENDPOINT = {
    ALL_DILUTIONS: '/dilutions',
}

const ORDERS_ENDPOINT = {
    ALL_ORDERS: '/orders',
    ONE_ORDER: '/orders/:id',
    COUNT_ORDERS: '/orders/count',
    RECENT_ORDERS: '/orders/recent',
}

const SELECTIONS_ENDPOINT = {
    ALL_SELECTIONS: '/selections',
    ONE_SELECTION: '/selections/:id',
}

const PRODUCTS_ENDPOINT = {
  ALL_PRODUCTS: '/products'
}

const ADMIN_ENDPOINT = {
    ADMIN_ALL_THERAPISTS: '/admin/therapists/all',
    ADMIN_ALL_CUSTOMERS: '/admin/customers/all',
    ADMIN_ALL_USERS: '/admin/users/all',
    ADMIN_ALL_CAPSULES: '/admin/capsules/all',
    ADMIN_ALL_MIXTURES: '/admin/mixtures/all',
    ADMIN_CREATE_THERAPIST: '/admin/therapists/create',
    ADMIN_UPDATE_THERAPIST: '/admin/therapists/update',
    ADMIN_CREATE_CUSTOMER: '/admin/customers/create',
    ADMIN_UPDATE_CUSTOMER: '/admin/customers/update',
    ADMIN_CREATE_ADDRESS: '/admin/address/create',
    ADMIN_UPDATE_ADDRESS: '/admin/address/update',
    ADMIN_DELETE_ADDRESS: '/admin/address/delete',
    ADMIN_DELETE_CAPSULE: '/admin/capsules/delete',
    ADMIN_REFILL_CREDITS: '/admin/account/credits/refill',
    ADMIN_REMOVE_CREDITS: '/admin/account/credits/remove',
}

const API = {
    ...CAPSULES_ENDPOINT,
    ...USERS_ENDPOINT,
    ...CUSTOMERS_ENDPOINT,
    ...MIXTURES_ENDPOINT,
    ...CUSTOM_MIXTURES_ENDPOINT,
    ...CATALOGUE_MIXTURES_ENDPOINT,
    ...DILUTIONS_ENDPOINT,
    ...ORDERS_ENDPOINT,
    ...CAPSULES_CONFIGURATIONS_ENDPOINT,
    ...SELECTIONS_ENDPOINT,
    ...PRODUCTS_ENDPOINT,
    ...ADMIN_ENDPOINT,
}

export default API
